const getInitialState = () => ({
  openRequests: [],
  failedRequests: [],
  updatedAt: 0,
  insuranceCompany: null,
  entries: []
});

export default {
  getInitialState
};
